import {
  LISTINGS_DEFAULT_SEARCH_PARAMS,
  LISTINGS_PER_PAGE,
  LISTINGS_PER_PAGE_MAP,
} from '@/features/listing/constants/listings-filters-constants';
import {
  type FiltersParams,
  MapParamsNames,
} from '@/features/listing/types/listing-filters-types';
import {
  ExtraFieldsNames,
  FiltersNames,
  GeoBboxNames,
  PaginationNames,
} from '@/features/listing/types/listing-filters-types';
import { type ListingType } from '@/features/listing/types/listing-types';
import getListingsFiltersParams from '@/features/listing/utils/get-listings-filters-params';
import { type Place } from '@/features/place/types/place-types';
// import convertGeoBoundsWithMinimalRadius from '@/features/place/utils/convert-geo-bounds-with-minimal-radius';

export default function prepareListingsSearchParams(
  searchParams: URLSearchParams,
  listingType: ListingType,
  placeBbox: Place['bbox'],
  isMap = false,
): URLSearchParams {
  const currentSearchParams: Partial<FiltersParams> = getListingsFiltersParams(searchParams);

  const latitudeSouthWestParams = searchParams.get(GeoBboxNames.LatitudeSouthWest);
  const longitudeSouthWestParams = searchParams.get(GeoBboxNames.LongitudeSouthWest);
  const latitudeNorthEastParams = searchParams.get(GeoBboxNames.LatitudeNorthEast);
  const longitudeNorthEastParams = searchParams.get(GeoBboxNames.LongitudeNorthEast);

  const sharedSearchParams: Record<string, string> = {
    ...LISTINGS_DEFAULT_SEARCH_PARAMS,
    ...currentSearchParams,
    [FiltersNames.ListingType]: listingType,
    [GeoBboxNames.LatitudeSouthWest]: latitudeSouthWestParams || String(placeBbox.latitudeSouthWest),
    [GeoBboxNames.LongitudeSouthWest]: longitudeSouthWestParams || String(placeBbox.longitudeSouthWest),
    [GeoBboxNames.LatitudeNorthEast]: latitudeNorthEastParams || String(placeBbox.latitudeNorthEast),
    [GeoBboxNames.LongitudeNorthEast]: longitudeNorthEastParams || String(placeBbox.longitudeNorthEast),
    [PaginationNames.PageSize]: searchParams.get(PaginationNames.PageSize) ?? String(LISTINGS_PER_PAGE),
  };

  const pageParam = searchParams.get(PaginationNames.PageNumber);
  const parsedPage = pageParam ? Number.parseInt(pageParam, 10) : 1;
  const page = Number.isFinite(parsedPage) && parsedPage > 0 ? parsedPage : 1;

  if (isMap) {
    sharedSearchParams[MapParamsNames.MapData] = 'true';
    sharedSearchParams[PaginationNames.PageSize] = String(LISTINGS_PER_PAGE_MAP);
  }

  return new URLSearchParams({
    ...sharedSearchParams,
    [ExtraFieldsNames.IncludeAvgRent]: 'true',
    [ExtraFieldsNames.IncludeTotalCount]: 'true',
    [PaginationNames.PageNumber]: String(page),
  });
}
